import { useCallback } from "react";
import { useSelector } from "react-redux";
import { normalizeSpecialistRoleKey } from "../helpers/activeSpecialistRoleHelper";
import { resolveAuthUserId } from "../helpers/flowEditPageHelper";
import { canOperateCmiRecord } from "../helpers/flowTraySurfaceHelper";

const useCanOperateFlowListRecord = () => {
  const authUser = useSelector((state) => state.auth?.user);
  const roleLogin = useSelector((state) => state.userRole?.roleLogin);
  const selectedRole = roleLogin?.isRoleSpecialistSelected
    ? roleLogin.roleSpecialistSelected
    : null;
  const roleKey = normalizeSpecialistRoleKey(selectedRole);

  const authUserId = resolveAuthUserId(authUser);
  return useCallback((record) => canOperateCmiRecord({
    record,
    roleKey,
    roleId: selectedRole?.id,
    userId: authUserId
  }), [authUserId, roleKey, selectedRole?.id]);
};

export default useCanOperateFlowListRecord;
